import React from 'react'
import css from '../styles/List.module.scss';

function List({title, active, setSelected, id}) {
    return <li className={`${css.list} ${active ? css[`active`] : {}}`}
    onClick={() => setSelected(id)}>{title}</li>;
}

export default List
